import { gql } from "@apollo/client";

export const GET_HOT_SPOTS = gql`
  query getHotSpots($type: String!) {
    getHotspot(device_type: $type) {
      hotspot_data {
        hotspots_id
        device_type
        hotspots_image
      }
      product_data {
        id
        product_id
        name
        url_key
        sku
        stock_status
        type_id
        uid
        hotspot_number
        hotspot_style
        image {
          url
          label
        }
      }
    }
  }
`;

export const GET_ALL_HOT_SPOTS = gql`
  query getAllHotspots($type: String!) {
    getAllHotspots(device_type: $type) {
      hotspot_data {
        hotspots_id
        title
        heading
        device_type
        type
        hotspots_image
        content
      }
    }
  }
`;

export const GET_HOT_SPOTS_DETAILS = gql`
  query getHotspotDetails($hotspots_id: String!) {
    getHotspotDetails(hotspots_id: $hotspots_id) {
      hotspot_data {
        hotspots_id
        device_type
        title
        heading
        content
        hotspots_image
      }
      product_data {
        id
        product_id
        name
        url_key
        sku
        stock_status
        type_id
        uid
        hotspot_number
        hotspot_style
        image {
          url
          label
        }
      }
    }
  }
`;

export const GET_3D_MODEL = gql`
  query get3dModel($id: String!) {
    getThreeDModel(product_id: $id) {
      url
      label
    }
  }
`;
